import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { useFormik } from "formik";

import { Option } from "~ui-components/components/atoms/option";
import { FillStrokeStyle } from "~ui-components/components/molecules/simple-style/fill-stroke";
import { VISUALISATION_COLORS } from "~ui-components/constants/colors";
import { PointCategoryConfigs } from "~ui-components/types/__generated/gql/graphql";

interface Slots {
	MarkerSettingsDrawer: any;
}

interface SlotProps {
	MarkerSettingsDrawer: any;
}

const Empty = () => null;

const defaultSlots: Slots = {
	MarkerSettingsDrawer: Empty,
};

interface Props {
	form: ReturnType<typeof useFormik<PointCategoryConfigs>>;
	attributes: string[];
	slots?: Slots;
	slotProps?: SlotProps;
	onOpenCustomLegend: () => void;
	onOpenMarkerDrawer: () => void;
	onMarkerSettingClose: () => void;
}

export const PointCategoryStyle = (props: Props) => {
	const {
		slots = {},
		slotProps = {},
		onMarkerSettingClose,
		onOpenCustomLegend,
		form,
		attributes,
	} = props;
	const { values, handleChange, handleSubmit, setFieldValue } = form;

	const Slots = {
		...defaultSlots,
		...slots,
	};

	return (
		<>
			<Stack spacing={3}>
				<FormControl sx={{ width: 200 }}>
					<InputLabel>Colour by</InputLabel>
					<Select
						name="valueField"
						onChange={(e) => {
							handleChange(e);
							void setFieldValue("isSymbolValuesCustomised", false);
						}}
						value={values.valueField}>
						{attributes.map((value) => (
							<Option
								key={value}
								value={value}>
								{value}
							</Option>
						))}
					</Select>
				</FormControl>

				<FormControl sx={{ width: 200 }}>
					<InputLabel>Color Ramp</InputLabel>
					<Select
						name="colorRamp"
						value={values?.colorRamp}
						onChange={(e) => {
							handleChange(e);
							void setFieldValue("isSymbolValuesCustomised", false);
						}}
						renderValue={(value) =>
							value && VISUALISATION_COLORS[value] ? (
								<Stack direction="row">
									{VISUALISATION_COLORS[value][9].slice(2).map((color) => (
										<Box
											key={color}
											sx={{ width: 20, height: 20, backgroundColor: color }}
										/>
									))}
								</Stack>
							) : null
						}>
						{Object.keys(VISUALISATION_COLORS).map((key) => (
							<Option
								key={key}
								value={key}>
								<Stack direction="row">
									{VISUALISATION_COLORS[key][9].slice(2).map((color) => (
										<Box
											key={color}
											sx={{ width: 20, height: 20, backgroundColor: color }}
										/>
									))}
								</Stack>
							</Option>
						))}
					</Select>
				</FormControl>

				<FillStrokeStyle {...props} />

				<Button
					sx={{ width: 200 }}
					variant="outlined"
					onClick={() => onOpenCustomLegend()}>
					Customise legend
				</Button>
			</Stack>
			<CardActions sx={{ justifyContent: "flex-end", p: 0, mt: 2 }}>
				<Button color="secondary">Cancel</Button>
				<Button
					variant="contained"
					onClick={() => handleSubmit()}>
					Save changes
				</Button>
			</CardActions>
			<Slots.MarkerSettingsDrawer
				onClose={onMarkerSettingClose}
				onChange={(value) => {
					onMarkerSettingClose();
					void form.setFieldValue("symbolStyle.basic.symbol", value);
				}}
				open={
					(slotProps as { MarkerSettingsDrawer: { open: boolean } })
						.MarkerSettingsDrawer?.open
				}
			/>
		</>
	);
};
